<template>
  <div>
    <b-card v-for="survey in surveyList" :key="survey" class="shadow atm-rounded my-2">
      <b-skeleton width="150px" height="30px"></b-skeleton>
      <b-container class="pl-0 mt-4">
        <b-row>
          <b-col cols="12" md="9">
            <b-skeleton></b-skeleton>
          </b-col>
          <b-col cols="12" md="3" class="d-md-flex justify-content-end py-4 p-md-0">
            <b-skeleton type="button" width="100px" ></b-skeleton>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      surveyList: [1, 2, 3, 4],
    };
  },
};
</script>
